import { createContext, useContext, useState, useCallback } from "react";

const ChatPopupContext = createContext(null);

export const useChatPopup = () => {
  const ctx = useContext(ChatPopupContext);
  if (!ctx) {
    throw new Error("useChatPopup must be used within ChatPopupProvider");
  }
  return ctx;
};

export const ChatPopupProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [chatTarget, setChatTarget] = useState(null);

  /**
   * Open the chat popup for a product.
   * @param {{ productId: string, productName: string, productPicture: string, ownerId: string, ownerName: string }} target
   */
  const openChat = useCallback((target) => {
    setChatTarget(target);
    setOpen(true);
  }, []);

  const closeChat = useCallback(() => {
    setOpen(false);
    // Keep chatTarget for a smooth close animation; clear after a delay
    setTimeout(() => setChatTarget(null), 300);
  }, []);

  return (
    <ChatPopupContext.Provider value={{ open, chatTarget, openChat, closeChat }}>
      {children}
    </ChatPopupContext.Provider>
  );
};
